import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const showPDPPercentRecommendedSelector = createSelector(testTargetOffersSelector, offers => offers.showPDPPercentRecommended || Empty.Object);

export { showPDPPercentRecommendedSelector };
